export default __webpack_public_path__ + "static/media/activity_icon.a438e62d.svg";